module.exports = __webpack_public_path__ + "static/media/Movingful-MWDG-Final-White-Square.0dd30d4e.svg";